import { enableProdMode, provideZonelessChangeDetection } from "@angular/core";
// import * as Sentry from "@sentry/angular";
import { environment } from "./environments/environment";

// Sentry.init({
//   dsn: "https://f65d1acbdb694087b2be5afec1115a48@o219666.ingest.us.sentry.io/1531493",
//   tunnel: environment.apiUrl + "/sentry/tunnel",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   tracePropagationTargets: [environment.fullUrl, environment.apiUrl],
//   tracesSampleRate: 1,
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1,
//   enableLogs: true,
//   sendDefaultPii: true,
// });

import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZonelessChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
